package top.wcpe.allincore.dsl.compiler.semantic.`native`.methods

import top.wcpe.allincore.dsl.compiler.ast.ExprAst
import top.wcpe.allincore.dsl.compiler.diag.DiagnosticCollector
import top.wcpe.allincore.dsl.compiler.semantic.`native`.Arity
import top.wcpe.allincore.dsl.compiler.semantic.`native`.MethodDescriptor
import top.wcpe.allincore.dsl.compiler.semantic.`native`.ResolveCtx

/** date.now()。 */
object DateNowMethod : MethodDescriptor {
    override val name: String = "now"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.today()。 */
object DateTodayMethod : MethodDescriptor {
    override val name: String = "today"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.year()。 */
object DateYearMethod : MethodDescriptor {
    override val name: String = "year"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.month()。 */
object DateMonthMethod : MethodDescriptor {
    override val name: String = "month"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.day()。 */
object DateDayMethod : MethodDescriptor {
    override val name: String = "day"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.dayOfWeek()。 */
object DateDayOfWeekMethod : MethodDescriptor {
    override val name: String = "dayOfWeek"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.weekOfYear()。 */
object DateWeekOfYearMethod : MethodDescriptor {
    override val name: String = "weekOfYear"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.dayOfYear()。 */
object DateDayOfYearMethod : MethodDescriptor {
    override val name: String = "dayOfYear"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.format(ms, pattern)。 */
object DateFormatMethod : MethodDescriptor {
    override val name: String = "format"
    override val arity: Arity = Arity.Fixed(2)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.parse(text, pattern)。 */
object DateParseMethod : MethodDescriptor {
    override val name: String = "parse"
    override val arity: Arity = Arity.Fixed(2)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.add(ms, amount, unit)。 */
object DateAddMethod : MethodDescriptor {
    override val name: String = "add"
    override val arity: Arity = Arity.Fixed(3)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** date.diff(ms1, ms2, unit)。 */
object DateDiffMethod : MethodDescriptor {
    override val name: String = "diff"
    override val arity: Arity = Arity.Fixed(3)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** 聚合 date 宿主 object 的所有方法描述符。 */
val DateApiMethodMap: Map<String, MethodDescriptor> = listOf(
    DateNowMethod,
    DateTodayMethod,
    DateYearMethod,
    DateMonthMethod,
    DateDayMethod,
    DateDayOfWeekMethod,
    DateWeekOfYearMethod,
    DateDayOfYearMethod,
    DateFormatMethod,
    DateParseMethod,
    DateAddMethod,
    DateDiffMethod,
).associateBy { it.name }
